var map = {
	"./damage-type-cold-16px.png": "090c",
	"./damage-type-death-16px.png": "05ae",
	"./damage-type-fire-16px.png": "f7ea",
	"./damage-type-normal-16px.png": "3c7f",
	"./damage-type-shock-16px.png": "1718",
	"./damage-type-spirit-16px.png": "290e",
	"./damage-type-toxic-16px.png": "55e8",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";